// extracted by mini-css-extract-plugin
module.exports = {"root":"Leaderboard_root__1RQA7"};